import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=b81465aa&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
import style0 from "./Report.vue?vue&type=style&index=0&id=b81465aa&prod&lang=scss&scoped=true"
import style1 from "./Report.vue?vue&type=style&index=1&id=b81465aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81465aa",
  null
  
)

export default component.exports